/**
 * Crew-member user selection contract for project services.
 *
 * A crew is staffed from two roles — Technicians and Crew Managers — so the
 * crew form's member picker offers the union of both groups, active users
 * only. The group ids and the query that fetches them live here so the
 * picker and its endpoint module cannot drift apart.
 *
 * Contains:
 * - CREW_MEMBER_GROUP_IDS   — the groups eligible to staff a crew
 * - buildCrewMemberUsersGrid — the odl-app grid descriptor for the picker
 *
 * Returns plain JS — no JSX.
 */

/** Technicians (11) and Crew Managers (1055) — the roles that staff a crew. */
export const CREW_MEMBER_GROUP_IDS = [11, 1055];

/**
 * Every eligible member fits one page, so the picker asks for one large
 * window rather than paging a dropdown.
 */
const CREW_MEMBER_PAGE_LIMIT = 10000;

/**
 * Build the odl-app grid descriptor selecting the users eligible for a crew.
 *
 * @returns {{filters: object, page: {limit: number, offset: number}}} A
 *   descriptor for `axiosBaseQuery`'s `grid` arg, which `buildGridParams`
 *   renders as `filter[group_id.in]` / `filter[is_active]` query params.
 */
export function buildCrewMemberUsersGrid() {
  return {
    filters: {
      group_id: { op: 'in', value: CREW_MEMBER_GROUP_IDS.join(',') },
      is_active: true,
    },
    page: { limit: CREW_MEMBER_PAGE_LIMIT, offset: 0 },
  };
}
